import { IMAGE_EMPTY_AVATAR } from 'common/configuration/constants';
import { getImageUrl, resolveGraphQlMediaPath } from 'common/tools/network/url';

export function resolveMainAvatarUrl(
  customizationAvatarPath: string | null | undefined,
  legacyMainAvatar: string | null | undefined
): string {
  if (customizationAvatarPath) {
    return resolveGraphQlMediaPath(customizationAvatarPath);
  }
  if (legacyMainAvatar) {
    return resolveGraphQlMediaPath(legacyMainAvatar);
  }
  return getImageUrl({ src: IMAGE_EMPTY_AVATAR });
}
